import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from './firebase';
import './App.css';

function ServerUnavailable() {
  const handleSignOut = () => {
    signOut(auth);
  };

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>🔧 Server Maintenance</h1>
        <p>Our servers are currently unavailable.</p>
        <p>We're working to get things back up and running!</p>
      </header>

      <div className="container" style={{ maxWidth: '600px', margin: '2rem auto', padding: '0 1rem', textAlign: 'center' }}>
        <h2>What's happening?</h2>
        <p>
          We're either performing scheduled maintenance or experiencing temporary technical difficulties.
          This usually only takes a few minutes.
        </p>

        <h2>What can you do?</h2>
        <ul style={{ textAlign: 'left', margin: '1rem auto', maxWidth: '400px', lineHeight: '1.8' }}>
          <li>Try refreshing the page in a few minutes</li>
          <li>Check back later if the issue persists</li>
          <li>Contact us at <a href="mailto:orchestral.dev@gmail.com" style={{ color: '#0064c8' }}>orchestral.dev@gmail.com</a> if this continues</li>
        </ul>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', marginTop: '2rem', flexWrap: 'wrap' }}>
          <button
            className="btn"
            onClick={handleRetry}
            style={{ backgroundColor: '#4caf50' }}
          >
            Try Again
          </button>
          <button
            className="btn"
            onClick={handleSignOut}
          >
            Sign Out
          </button>
        </div>

        <div style={{ marginTop: '2rem', padding: '1rem', backgroundColor: '#f5f5f5', borderRadius: '5px', color: '#666' }}>
          <small>
            <strong>Status:</strong> WebSocket connection failed<br />
            If you continue to see this message, our backend servers may be down for maintenance.
          </small>
        </div>
      </div>
    </div>
  );
}

export default ServerUnavailable;
